module.exports = __webpack_public_path__ + "static/media/mazda.404d8459.png";